import { CLEAR_SITE_TYPE_CREATE_ERRORS, RECEIVE_SITE_TYPE_CREATE_FAILURE, RECEIVE_SITE_TYPE_CREATE_SUCCESS, REQUEST_SITE_TYPE_CREATE_ACTION } from '../action/siteTypeAction'

export const initialState = {
  isFetching: false,
  errors: []
}

const siteTypesCreateReducer = (reduxState = initialState, action) => {
  const { payload, type } = action
  switch (type) {
    case REQUEST_SITE_TYPE_CREATE_ACTION:
      return {
        ...reduxState,
        isFetching: true,
        errors: []
      }

    case RECEIVE_SITE_TYPE_CREATE_SUCCESS:
      return {
        ...reduxState,
        isFetching: false,
        errors: []
      }

    case RECEIVE_SITE_TYPE_CREATE_FAILURE:
      return {
        ...reduxState,
        isFetching: false,
        errors: payload.errors
      }

    case CLEAR_SITE_TYPE_CREATE_ERRORS:
      return {
        ...reduxState,
        isFetching: false,
        errors: []
      }

    default:
      return reduxState
  }
}

export default siteTypesCreateReducer
